import { NAME } from './constants';

export const RESET_REDUCER = `${NAME}/RESET_REDUCER`;
export const CHANGE_TAB = `${NAME}/CHANGE_TAB`;

export const CHANGE_ALL_NOTIFS = `${NAME}/CHANGE_ALL_NOTIFS`;
export const CHANGE_SUB_NOTIF = `${NAME}/CHANGE_SUB_NOTIF`;
export const SET_USER_NOTIFS = `${NAME}/SET_USER_NOTIFS`;

export const SET_TASK_FILTERS = `${NAME}/SET_TASK_FILTERS`;
export const CHANGE_SUBFILTER_CHECKED = `${NAME}/CHANGE_SUBFILTER_CHECKED`;
export const CHANGE_FILTER_CHECKED_WITHOUT_SUBFILTER = `${NAME}/CHANGE_FILTER_CHECKED_WITHOUT_SUBFILTER`;
export const CHANGE_FILTER_CHECKED = `${NAME}/CHANGE_FILTER_CHECKED`;
